
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import HomeFooter from '@/components/home/HomeFooter.vue';
  import HomeHeader from '@/components/home/HomeHeader.vue';
  import HomeLivesImpacted from '@/components/home/HomeLivesImpacted.vue';
  import HomeAbout from '../components/home/HomeAbout.vue';
  import NavBar from '../components/NavBar';
  import HomeCategories from '@/components/home/HomeCategories/HomeCategories.vue';
  import HomeCategoriesMobile from '@/components/home/HomeCategories/HomeCategoriesMobile.vue';
  import HomeChallenges from '@/components/home/HomeChallenges/HomeChallenges.vue';
  import HomeHowItWorks from '@/components/home/HomeHowItWorks/HomeHowItWorks.vue';
  import HomeIdeasPlace from '@/components/home/HomeIdeasPlace/HomeIdeasPlace.vue';
  import HomePartnerships from '@/components/home/HomePartnerships/HomePartnerships.vue';
  import {authModule, inProgressChallengesState} from '@/utils/store-acessor';
  import {
    changeNavbarTheme,
    NavBarTheme,
    navDarkTheme,
    navLightTheme,
    navMiscTheme
  } from '@/components/NavBar/navbar-theme';
  import {Watch} from 'vue-property-decorator';
  import {Route} from 'vue-router';
  import HomeCovi19 from '@/components/home/HomeCovi19.vue';
  import HomeSixChallenges from '@/components/home/HomeSixChallenges.vue';
  import HomeCovi19New2 from '@/components/home/HomeCovi19New2.vue';
  import HomeJoinSocialLeague from '@/components/home/HomeJoinSocialLeague.vue';
  import {ScrollEvent} from '@/models/scroll-event';
  import {ImagesModel} from '@/models/images.model';
  import {ImagesApi} from '@/api/images.api';
  import {take} from 'rxjs/operators';

  export type HeaderElementsIdS
          = 'homeHeader' |
          'homeChallenges' |
          'homeCategories' |
          'homeAbout' |
          'homeHowItWorks' |
          'homeIdeasPlace' |
          'homePartnerships' |
          'homeLivesImpacted' |
          'covi19' |
          'homeFooter' |
          'homeJoinSocialLeague';

  @Component({
    components: {
      HomeJoinSocialLeague,
      HomeCovi19New2,
      HomeSixChallenges,
      HomeCovi19,
      NavBar,
      HomeHeader,
      HomeChallenges,
      HomeCategories,
      HomeCategoriesMobile,
      HomeHowItWorks,
      HomeIdeasPlace,
      HomeAbout,
      HomePartnerships,
      HomeLivesImpacted,
      HomeFooter,
    },
    metaInfo() {
      return {
        title: 'Ikone'
      };
    },
  })
  export default class Home extends Vue {

    @authModule.Getter('isAuthenticated') readonly isAuthenticated!: boolean;
    elements: HeaderElementsIdS[] = [
      'homeHeader',
      'homeChallenges',
      'homeCategories',
      'homeAbout',
      'homeHowItWorks',
      'homeIdeasPlace',
      'homePartnerships',
      'homeLivesImpacted',
      'homeFooter',
      'covi19',
      'homeJoinSocialLeague'
    ];
    images: ImagesModel | null = null;

    get headerImage(): string {
      return this.images?.frontend_main_image || ''
    }

    get footerImage(): string {
      return this.images?.frontend_footer_image || ''
    }

    mounted() {
      new ImagesApi().fetchImages()
              .pipe(take(1))
              .subscribe((images) => this.images = images)

      inProgressChallengesState.fetchAll({page: 1})

      const destinyName = this.$route.hash.slice(1);
      const destiny = this.$refs[destinyName];
      if (!!destiny) {
        // @ts-ignore
        this.$vuetify.goTo(destiny, {offset: -65, duration: 2000})
      }
    }

    @Watch('$route', {deep: true, immediate: true})
    onWatchHomeRoutes(v: Route) {
      if (!!v && v.name == 'home') {
        const destinyName = v.hash.slice(1);
        const destiny = this.$refs[destinyName] || this.$refs.homeHeader;
        if (destiny) {
          // @ts-ignore
          this.$vuetify.goTo(destiny, {offset: -65, duration: 2000})
        }
      }
    }

    updateState(element: ScrollEvent) {
      const theme = this.selectTheme(element);
      changeNavbarTheme(theme);
    }

    selectTheme(element: ScrollEvent): NavBarTheme {
      const header = element['homeHeader'];
      const covid19 = element['covi19'];
      const challenges = element['homeChallenges'];
      const categories = element['homeCategories'];
      const howItWork = element['homeHowItWorks'];
      const gzero = element['homeIdeasPlace'];
      const partner = element['homePartnerships'];
      const footer = element['homeFooter'];
      const socialLeague = element['homeJoinSocialLeague'];
      if (this.$vuetify.breakpoint.mdAndUp) {
        if (header?.isInViewport) {
          return navLightTheme;
        }
        if (socialLeague?.isInViewport) {
          return navLightTheme;
        }
        if (covid19?.isInViewport) {
          return navLightTheme
        }
        if (challenges?.isInViewport) {
          return navDarkTheme
        }
        if (categories?.isInViewport) {
          return navDarkTheme
        }
        if (howItWork?.isInViewport) {
          return navDarkTheme
        }
        if (howItWork?.isInViewport) {
          return navDarkTheme
        }
        if (gzero?.isInViewport) {
          if (this.$vuetify.breakpoint.mdAndUp) {
            return navMiscTheme;
          } else {
            return navDarkTheme;
          }
        }
        if (partner?.isInViewport) {
          return navDarkTheme;
        }
        if (footer?.isInViewport) {
          return navLightTheme
        }
      }

      return navLightTheme;
    }
  }
